/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import user from '@/store/modules/globalStore';

function auth(code) {
  try {
    if (code === '') return true;
    var powers = user.state.user.powers ? user.state.user.powers.map(function (v) {
      return v.code;
    }) : [];
    return powers.includes(code);
  } catch (error) {
    return false;
  }
}

var install = function install(Vue) {
  Vue.prototype.$oauth = auth;
};

export { auth };
export default install;